import getColor from "@insite/mobius/utilities/getColor";
import { headerStyles } from "@solveindustrial/Overrides/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

headerStyles.headerGridContainer = {
    ...headerStyles.headerGridContainer,
    css: css`
        ${headerStyles.headerGridContainer?.css}
        margin-bottom: 40px;
        ${mediaQueriesBP.maxMD} {
            margin-bottom: 24px;
        }
    `,
};

headerStyles.title = {
    ...headerStyles.title,
    variant: "h1",
};

headerStyles.buttonGridItem = {
    ...headerStyles.buttonGridItem,
    css: css`
        ${headerStyles.buttonGridItem?.css}
        align-items: center !important;
        display: flex;
    `,
};

headerStyles.buttonsHiddenContainer = {
    ...headerStyles.buttonsHiddenContainer,
    css: css`
        ${headerStyles.buttonsHiddenContainer?.css}
        align-items: center !important;
        display: flex;
    `,
};

headerStyles.shareEntityButtonStyles = {
    ...headerStyles.shareEntityButtonStyles,
    button: {
        ...headerStyles.shareEntityButtonStyles?.button,
        css: css`
            ${headerStyles.printButton?.css}
            border: 1px solid ${getColor(colorStrings.primaryMain)};
            color: ${getColor(colorStrings.primaryMain)};
        `,
    },
};

headerStyles.printButton = {
    ...headerStyles.printButton,
    buttonType: "solid",
    variant: "primary",
};

headerStyles.downloadButton = {
    ...headerStyles.downloadButton,
    buttonType: "outline",
    variant: "secondary",
    css: css`
        margin-left: 10px;
        min-width: 142.7px;
    `,
};
